export function formatCoords(lat, lng) {
  if (lat == null || lng == null) return "";
  return `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`;
}

export async function copyCoords(lat, lng) {
  const text = formatCoords(lat, lng);
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** Standard geo URI — not an invented Avenza scheme. */
export function geoUri(lat, lng) {
  if (lat == null || lng == null) return "";
  return `geo:${Number(lat)},${Number(lng)}`;
}
